import {useNavigate} from "react-router";
import {useEffect, useState} from "react";
import {useAuthStore} from "../../../store/auth.store";
import {PartnerApi} from "../../../api/partner.api";
import {toast} from "react-toastify";
import {useTranslation} from "../../../hooks/useTranslation";

export default function DeliveryAddressEditForm({handleClose, company_id, address, callback}) {
    const { t } = useTranslation();
    const token = useAuthStore((state) => state.token);

    const createDeliveryAddress = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const result = PartnerApi.companyDeliveryAddressUpdate({
            token,
            company_id,
            address_id: address.address_id,
            data: {
                city: formData.get("city"),
                country: formData.get("country"),
                name: formData.get("name"),
                street: formData.get("street"),
                zip: formData.get("zip"),
                building: formData.get("building"),
            }
        });
        result.then((result) => {
            if ("error" in result) {
                toast.error(result.error);
                return;
            }

            handleClose();
            if (callback) {
                callback();
            }
        });
        return false;
    }
    return (
        <form onSubmit={(e) => createDeliveryAddress(e)}>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.name")}</label>
                <input name="name" className="form-control" defaultValue={address.name} />
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.building")}</label>
                <input name="building" className="form-control" defaultValue={address.building} />
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.street")}</label>
                <input name="street" className="form-control" defaultValue={address.street} />
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.city")}</label>
                <input name="city" className="form-control" defaultValue={address.city} />
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.zip")}</label>
                <input name="zip" className="form-control" defaultValue={address.zip} />
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.country")}</label>
                <input name="country" className="form-control" defaultValue={address.country} />
            </div>


            <button type="submit" className="btn btn-primary">{t("common.save")}</button>
        </form>
    );
}